import React from 'react';
import './Main_gift_flow.css';

import {  Redirect } from 'react-router-dom';
import { Link } from 'react-router-dom';
import {Helmet} from "react-helmet";
import ReCAPTCHA from "react-google-recaptcha";


import Tracker from '../../../layout_components/Tracker/Tracker.js';
import Gifting_step_1 from '../Gifting_step_1/Gifting_step_1.js';
import Gifting_step_2 from '../Gifting_step_2/Gifting_step_2.js';
import Gifting_step_3 from '../Gifting_step_3/Gifting_step_3.js';
import Gifting_step_4 from '../Gifting_step_4/Gifting_step_4.js';
import Header_for_multistep from '../../../layout_components/Header_for_multistep/Header_for_multistep';
import Overlay_popup from '../../../general_components/Overlay_popup/Overlay_popup';

import GGApi from '../../../../utils/GGApi.js';

import dates from '../../../../utils/dates.js';
import validations from '../../../../utils/validations.js';
import Gifting_thank_you from '../Gifting_thank_you/Gifting_thank_you';
import Monthly_gift_success from '../Monthly_gift_success/Monthly_gift_success.js';
import Payment_methods from '../../../Payment_methods/Payment_methods';
import GG_loader from '../../../general_components/GG_loader/GG_loader';
import config from '../../../../utils/config';
import gg_fees from '../../../../utils/gg_pricing.js';
import {getSendFeeCategorySubtext,updatePmListFeeSubtext,} from '../../../../utils/monthly_gift_pricing.js';
import {
    countSelectablePaymentMethods,
    isLegacyAchPaymentMethod,
    LEGACY_BANK_EXPIRED_MESSAGE,
    LEGACY_BANK_EXPIRED_PICK_OTHER_MESSAGE,
} from '../../../../utils/legacyAchPaymentMethod.js';
import { getRegistryReturnSlug } from '../../../../utils/registry_return.js';
import GG_confetti from '../../../general_components/GG_confetti/GG_confetti';
import gg_icon from '../../../../images/logos/gg_logo_icon.png';

import amplitude from 'amplitude-js';
import {
    logMonthlyFlowStarted,
    logMonthlyFlowStepCompleted,
    logMonthlySetupStarted,
    logMonthlySetupCompleted,
} from '../../../../utils/monthlyGiftAnalytics';
amplitude.getInstance().init(config.amp_key);



let guest_payment_recaptcha = React.createRef();

class Main_gift_flow extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            tokenIsValid: true,
            guest: '',

            loading: false,

            // navigations
            currentStep: 1,
            last_step: 0,
            open_payments: false,
            guest_overlay_open: false,
            gg_help_box: false,

            // captcha
            captcha_token: '',

            // interactions with stripe
            payment_intent: '',
            new_payment_method: {},
            save_method: false,

            // payments
            payment_methods: [],
            selected_payment_method: '',
            accept_additional_charges: true,
            failed_count: 0,

            // chosen fee
            choose_fee_value: 5,

            buttonLinks: false,
            button4Active: false,
            sent: false,

            // gift details
            from: '',
            sender_email: '',

            Gift_for: '',
            occasion: '',
            greeting: '',
            file: null,
            selected_goals: [],

            Gift_amount: '',
            other_gift_amount: '',
            schedule_delivery: 'later',
            Gift_delivery_date: '',
            Gift_delivery_shown_date: '',
            Gift_delivery_time: '',
            Gift_delivery_shown_time: '',
            timezone: {id: 1, title: "Eastern Time", tz: "America/New_York" },

            Send_to: '',
            channel: '',
            send_to_number: '',
            send_to_email: '',
            
            date: '',
            phone_support:'',

            // gifting page gift flow
            ref: null,
            receiver: null,
            receiver_number: null,

            // newsletter opt-in
            opt_in: true,

            // gift matching (from registry or matching_for_gift API)
            matching_available: false,
            matching_remaining_cents: 0,
            matching_multiplier: 2,
            matching_help_box: false,
            monthly_duration_help_box: false,

            // plan–gift link (registry flow): account_id from URL, set on gift and sent to backend
            account_id: null,

            // Monthly Gifts: frequency + eligibility
            Gift_frequency: 'one_time',
            monthly_eligible: false,
            gift_duration_months: 12,
            monthly_gift_success: false,
            monthly_next_gift_date: '',
            /** for monthly flow */
            monthly_gift_flow: false,
            // post-send: from backend when matching was applied
            match_applied: false,
            match_amount: 0
        }

         /* gift schema: 
                    Gift_for: ,
                    greeting: ,
                    Gift_amount: ,
                    Gift_delivery_date: ,
                    Send_to: ,
                    channel: ,
                    send_to_number: ,
                    send_to_email: ,
                    gift_status: ,
                    gift_id: ,
                    gift_from:
            */

        this.handleButtonClick = this.handleButtonClick.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleDateChange = this.handleDateChange.bind(this);
        this.handleDollarInput = this.handleDollarInput.bind(this);
        this.handlePhoneChange  = this.handlePhoneChange.bind(this);
        this.handlePastePhone   = this.handlePastePhone.bind(this);
        this.updateChannel = this.updateChannel.bind(this);
        this.sendAnotherGift = this.sendAnotherGift.bind(this);
        this.handleOverlayBack = this.handleOverlayBack.bind(this);
        this.remember_gift = this.remember_gift.bind(this);
        this.handleDatePicker = this.handleDatePicker.bind(this);

        this.save_gift_for_oauth = this.save_gift_for_oauth.bind(this)

        this.handlePicChange = this.handlePicChange.bind(this);
        this.handleRemoveMedia = this.handleRemoveMedia.bind(this);
        this.setGiftFrequency = this.setGiftFrequency.bind(this);
        this.setGiftDurationMonths = this.setGiftDurationMonths.bind(this);
        this.handleMonthlyGiftSubmit = this.handleMonthlyGiftSubmit.bind(this);
        this.finishMonthlyGiftAfterPayment = this.finishMonthlyGiftAfterPayment.bind(this);

        this.removeSelectedPm = this.removeSelectedPm.bind(this);
        this.removePmFromListById = this.removePmFromListById.bind(this);
        this.handleLegacyBankSelectedForMonthly = this.handleLegacyBankSelectedForMonthly.bind(this);

        this.goToPayments = this.goToPayments.bind(this);
        this.updateCard = this.updateCard.bind(this);
        this.bankNext = this.bankNext.bind(this);
        this.handleDDSelection = this.handleDDSelection.bind(this);
        this.toggle = this.toggle.bind(this);

        
        this.pi_create = this.pi_create.bind(this);
        this.pi_update_recipient = this.pi_update_recipient.bind(this);
        this.pi_update_amount = this.pi_update_amount.bind(this);

        this.renderCaptcha = this.renderCaptcha.bind(this);
        this.handleRecaptcha = this.handleRecaptcha.bind(this);
        this.resetCaptcha = this.resetCaptcha.bind(this);
        this.logMonthlyStepComplete = this.logMonthlyStepComplete.bind(this);

    }

    /** monthly flow step completion (reordered flow only). */
    logMonthlyStepComplete(step) {
        if (!this.isMonthlyGiftFlow()) return;
        const stepName = this.getTrackerTags()[step - 1] || `Step ${step}`;
        logMonthlyFlowStepCompleted(step, stepName, {
            account_id: this.state.account_id || null,
            guest: !!this.state.guest,
        });
    }

    // Apply monthly_eligible + Gift_frequency after matching_for_gift returns
    applyMonthlyFlowFromApi(apiResult, urlFrequency, savedGift, accountId = null) {
        const monthly_eligible = !!(apiResult && apiResult.monthly_eligible);
        const saved = savedGift || null;

        let gift_frequency = 'one_time';
        let monthly_gift_flow = false;

        if (!monthly_eligible) {
            gift_frequency = 'one_time';
            monthly_gift_flow = false;
        } else if (urlFrequency === 'monthly') {
            gift_frequency = 'monthly';
            monthly_gift_flow = true;
        } else if (saved && saved.Gift_frequency === 'monthly') {
            gift_frequency = 'monthly';
            monthly_gift_flow = !!(saved.monthly_gift_flow);
        }

        const updates = {
            monthly_eligible,
            Gift_frequency: gift_frequency,
            monthly_gift_flow,
        };

        if (saved && saved.gift_duration_months != null && saved.gift_duration_months !== '') {
            updates.gift_duration_months = saved.gift_duration_months;
        }

        // Monthly deep link only: default first delivery to now
        if (monthly_eligible && urlFrequency === 'monthly') {
            updates.schedule_delivery = 'now';
        }

        this.setState(prev => ({
            ...updates,
            payment_methods: updatePmListFeeSubtext(prev.payment_methods, gift_frequency === 'monthly'),
        }));

        if (monthly_gift_flow && urlFrequency === 'monthly') {
            let guest = true;
            try {
                guest = !JSON.parse(localStorage.getItem('user'));
            } catch (e) {
                guest = true;
            }
            logMonthlyFlowStarted({
                source: 'monthly link',
                account_id: accountId != null ? accountId : (saved && saved.account_id != null ? saved.account_id : null),
                guest,
            });
        }
    }

    /** Snapshot of in-progress gift for remember_gift / OAuth / localStorage */
    buildGiftSnapshot(extraFields) {
        const gift = {
            from: this.state.from,
            sender_email: this.state.sender_email,

            Gift_for: this.state.Gift_for,
            occasion: this.state.occasion,
            greeting: this.state.greeting,
            file: this.state.file,
            selected_goals: this.state.selected_goals,

            Gift_amount: this.state.Gift_amount,
            other_gift_amount: this.state.other_gift_amount,
            Gift_delivery_date: this.state.Gift_delivery_date,
            Gift_delivery_shown_date: this.state.Gift_delivery_shown_date,
            Gift_delivery_time: this.state.Gift_delivery_time,
            Gift_delivery_shown_time: this.state.Gift_delivery_shown_time,
            schedule_delivery: this.state.schedule_delivery,

            Send_to: this.state.Send_to,
            channel: this.state.channel,
            send_to_number: this.state.send_to_number,
            send_to_email: this.state.send_to_email,

            date: this.state.date,
            phone_support: this.state.phone_support,
            choose_fee_value: this.state.choose_fee_value,

            Gift_frequency: this.state.Gift_frequency,
            gift_duration_months: this.state.gift_duration_months,
            monthly_gift_flow: this.state.monthly_gift_flow,

            resume_payments: this.state.open_payments,
            currentStep: this.state.currentStep,
            last_step: this.state.last_step,
        };
        return extraFields ? { ...gift, ...extraFields } : gift;
    }

    /** Restore saved gift fields (App state, localStorage after OAuth) */
    restoreGiftFromSnapshot(gift) {
        if (!gift) {
            return;
        }
        this.setState(prev => ({
            from: gift.from,
            sender_email: gift.sender_email,

            Gift_for: gift.Gift_for,
            occasion: gift.occasion,
            greeting: gift.greeting,
            file: gift.file,
            selected_goals: gift.selected_goals || [],

            Gift_amount: gift.Gift_amount,
            other_gift_amount: gift.other_gift_amount,
            Gift_delivery_date: gift.Gift_delivery_date,
            Gift_delivery_shown_date: gift.Gift_delivery_shown_date,
            Gift_delivery_time: gift.Gift_delivery_time,
            Gift_delivery_shown_time: gift.Gift_delivery_shown_time || gift.Gift_delivery_time,
            schedule_delivery: gift.schedule_delivery,

            Send_to: gift.Send_to,
            channel: gift.channel,
            send_to_number: gift.send_to_number,
            send_to_email: gift.send_to_email,

            date: gift.date,
            phone_support: gift.phone_support,
            choose_fee_value: gift.choose_fee_value,

            ...(gift.Gift_frequency != null ? { Gift_frequency: gift.Gift_frequency } : {}),
            ...(gift.gift_duration_months != null && gift.gift_duration_months !== ''
                ? { gift_duration_months: gift.gift_duration_months }
                : {}),
            ...(gift.monthly_gift_flow != null ? { monthly_gift_flow: !!gift.monthly_gift_flow } : {}),
            ...(gift.payment_intent ? { payment_intent: gift.payment_intent } : {}),
            ...(gift.resume_payments ? {
                open_payments: true,
                currentStep: 0,
                last_step: gift.last_step || 4,
                buttonLinks: true,
            } : {}),
            ...(gift.Gift_frequency != null
                ? {
                    payment_methods: updatePmListFeeSubtext(
                        prev.payment_methods,
                        gift.Gift_frequency === 'monthly'
                    ),
                }
                : {}),
        }));
    }

    /** Return URL for login/signup links so auth can send the user back into gifting */
    getGiftAuthReturnUrl({ resumePayments = false } = {}) {
        const searchString = (this.props.location && this.props.location.search) || '';
        const params = new URLSearchParams(searchString.startsWith('?') ? searchString.slice(1) : searchString);
        if (resumePayments) {
            params.set('resume_payments', '1');
        } else {
            params.delete('resume_payments');
        }
        const qs = params.toString();
        return qs ? `/give-a-gift?${qs}` : '/give-a-gift';
    }

    /** Reopen payment methods after returning from login */
    resumePaymentsAfterAuth() {
        this.setState({
            open_payments: true,
            currentStep: 0,
            last_step: 4,
            buttonLinks: true,
        });
    }

    /** Exit gifting flow: last visited registry (session), else home or landing */
    getGiftFlowExitUrl() {
        const slug = getRegistryReturnSlug();
        if (slug) {
            return `/registry/${slug}`;
        }
        if (!this.state.guest) {
            return '/home';
        }
        return '/';
    }

    setGiftFrequency(frequency) {
        const next = frequency === 'monthly' ? 'monthly' : 'one_time';
        amplitude.getInstance().logEvent('gifting: select gift frequency', { frequency: next });
        this.setState(prev => ({
            Gift_frequency: next,
            payment_methods: updatePmListFeeSubtext(prev.payment_methods, next === 'monthly'),
        }));
    }
    
    /** reordered flow for monthly flow */
    isMonthlyGiftFlow() {
        return this.state.monthly_gift_flow;
    }

    isMonthlyFrequency() {
        return this.state.Gift_frequency === 'monthly';
    }

    getTrackerTags() {
        if (this.isMonthlyGiftFlow()) {
            return ['Gift Details', 'Greeting', 'Receiver Details', 'Confirm & Pay'];
        }
        return ['Greeting', 'Gift Details', 'Receiver Details', 'Confirm & Pay'];
    }

    getConfirmButtonText() {
        return this.isMonthlyFrequency() ? 'Start Monthly Gift' : 'Confirm & Send';
    }

    /** Step-aware CTA label — derived at render so it stays in sync with step + frequency */
    getStepButtonText() {
        if (this.state.currentStep === 4 && !this.state.open_payments) {
            return this.getConfirmButtonText();
        }
        return 'Next';
    }

    /** Format ~1 month from today for monthly gift summary  */
    getNextMonthlyGiftDateLabel() {
        const d = new Date();
        d.setMonth(d.getMonth() + 1);
        return d.toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' });
    }

    setGiftDurationMonths(value) {
        const parsed = parseInt(String(value), 10);
        this.setState({
            gift_duration_months: isNaN(parsed) ? '' : parsed,
        });
    }


    /**
     * Step 2 (gift details)validations (gift amount, months if monthly, schedule).
     * Returns true when the user may advance past Gift Details.
     */
    validateGiftDetailsStep() {
        const isMonthlyFrequency = this.isMonthlyFrequency();
        const gift_amount = Number(this.state.Gift_amount.slice(1));

        if (isNaN(gift_amount)) {
            if (this.state.guest) {
                alert('Please input a valid gift amount, between $5 - $500. For a larger gift amount, please create a Greatest Gift account at app.GreatestGiftApp.com/new_account');
            } else {
                alert('Please input a valid gift amount, between $5 - $5,000');
            }
            return false;
        }
        if (this.state.guest && (gift_amount < 5 || gift_amount > 500)) {
            alert('Please input a valid gift amount, between $5 - $500. For a larger gift amount, please create a Greatest Gift account at app.GreatestGiftApp.com/new_account');
            return false;
        }
        if (!this.state.guest && (gift_amount < 5 || gift_amount > 5000)) {
            alert('Please input a valid gift amount, between $5 - $5,000');
            return false;
        }
        if (isMonthlyFrequency) {
            const months = Number(this.state.gift_duration_months);
            if (isNaN(months) || months < 2 || months > 120) {
                alert('Please enter a number of months between 2 and 120.');
                return false;
            }
        }
        if ((this.state.schedule_delivery === 'later' && !(this.state.Gift_delivery_date.length === 10))
            || (this.state.schedule_delivery === 'later' && !dates.validateDate(this.state.Gift_delivery_date))) {
            alert('Please input a valid delivery date in the following format:\nMM/DD/YYYY');
            return false;
        }
        if (this.state.schedule_delivery === 'later' && !dates.checkOneYear(this.state.Gift_delivery_date)) {
            alert('Please enter a delivery date within the following year');
            return false;
        }
        if (this.state.schedule_delivery === 'later' && !this.state.Gift_delivery_time) {
            alert('Please select a gift delivery time');
            return false;
        }
        if (this.state.schedule_delivery === 'later' && this.state.Gift_delivery_time &&
            this.state.Gift_delivery_date === dates.today() &&
            dates.militarizeTime(this.state.Gift_delivery_time.title) < dates.current_time()
        ) {
            alert('Gift delivery time cannot be in the past');
            return false;
        }
        return true;
    }

    advanceAfterGiftDetails(step) {
        if (this.state.selected_payment_method && this.state.payment_intent) {
            this.pi_update_amount(this.state.selected_payment_method, this.state.payment_intent);
        }
        const giftDetailsEvent = { step };
        if (this.isMonthlyFrequency()) {
            giftDetailsEvent.gift_frequency = 'monthly';
        }
        amplitude.getInstance().logEvent('gifting: submit gift details', giftDetailsEvent);
        if (this.isMonthlyFrequency()) {
            this.logMonthlyStepComplete(step);
        }
        this.setState({ currentStep: step + 1 });
    }

    /** Build gift payload for monthly setup/finalize APIs */
    buildMonthlyGiftPayload() {
        const gift = {
            Gift_for: this.state.Gift_for,
            greeting: this.state.greeting,
            selected_goals: this.state.selected_goals,
            Gift_amount: this.state.Gift_amount.slice(1),
            Gift_delivery_date: this.state.schedule_delivery === 'later'
                ? dates.sqlizeDate(this.state.Gift_delivery_date) : '',
            Gift_delivery_time: this.state.schedule_delivery === 'later'
                ? dates.militarizeTime(this.state.Gift_delivery_time.title) : '',
            schedule_delivery: this.state.schedule_delivery,
            Send_to: this.state.Send_to,
            channel: this.state.channel,
            send_to_number: this.state.send_to_number,
            send_to_email: this.state.send_to_email.toLowerCase(),
            gift_from: this.state.from,
            sender_email: this.state.sender_email.toLowerCase(),
            accepted_charges: this.state.accept_additional_charges,
            choose_fee_value: this.state.choose_fee_value ? Number(this.state.choose_fee_value) : 0,
            duration_months: Number(this.state.gift_duration_months),
        };
        if (this.state.account_id) {
            gift.account_id = this.state.account_id;
        }
        return gift;
    }

    /** Upload media, finalize plan, show success overlay */
    finishMonthlyGiftAfterPayment(setupRes, gift) {
        return GGApi.upload_media(this.state.file, 'greetings-media').then((mediaResponse) => {
            let mediaUrl = '';
            if (mediaResponse.errors) {
                console.log(mediaResponse.errors[0].detail);
                alert(`${mediaResponse.errors[0].detail}\nGift will proceed without greeting media.`);
            } else if (mediaResponse.mediaUrl) {
                mediaUrl = mediaResponse.mediaUrl;
            }

            const finalizePayload = {
                plan_id: setupRes.plan_id,
                payment_intent_id: setupRes.payment_intent_id,
                gift,
                media_url: mediaUrl,
                ref: this.state.ref || null,
            };
            if (this.state.guest) {
                finalizePayload.captcha = this.state.captcha_token;
            }

            return GGApi.monthly_gift_finalize(finalizePayload);
        }).then((finalRes) => {
            if (finalRes && finalRes.captcha === false) {
                alert('Encountered error with captcha validation. Please try again!');
                this.resetCaptcha(guest_payment_recaptcha);
                this.setState({ loading: false });
                return;
            }
            if (!finalRes || finalRes.success !== true) {
                alert((finalRes && finalRes.message) || 'Could not complete monthly gift setup. Please contact support.');
                this.setState({ loading: false });
                return;
            }
            this.props.forget_gift();
            logMonthlySetupCompleted({
                gift_amount: this.state.Gift_amount,
                duration_months: this.state.gift_duration_months,
                guest: !!this.state.guest,
                pm_type: this.state.selected_payment_method && this.state.selected_payment_method.type,
                match_applied: finalRes.match_applied === true,
                account_id: this.state.account_id || null,
            });
            this.setState({
                loading: false,
                monthly_gift_success: true,
                monthly_next_gift_date: finalRes.next_gift_date || this.getNextMonthlyGiftDateLabel(),
                match_applied: finalRes.match_applied === true,
                match_amount: typeof finalRes.match_amount === 'number' ? finalRes.match_amount : 0,
            });
        }).catch((err) => {
            console.log(err);
            alert('Something went wrong completing your monthly gift. Please contact support.');
            this.setState({ loading: false });
        });
    }

    handleMonthlyGiftSubmit() {
        if (!this.state.selected_payment_method) {
            alert('Please select a payment method');
            return;
        }
        if (isLegacyAchPaymentMethod(this.state.selected_payment_method)) {
            this.handleLegacyBankSelectedForMonthly(this.state.selected_payment_method);
            return;
        }
        if (this.state.choose_fee_value && isNaN(this.state.choose_fee_value)) {
            alert('Please enter a valid custom fee amount');
            return;
        }
        if (!this.state.account_id) {
            alert('Something went wrong. Please try to reopen the link or contact support.');
            return;
        }
        if (this.state.guest && !this.state.captcha_token) {
            alert('Please fill out the captcha requirement.');
            return;
        }
        if (this.state.guest && this.state.selected_payment_method.type === 'ACH') {
            alert('Please log in to use a bank account for monthly gifts.');
            return;
        }

        const gift = this.buildMonthlyGiftPayload();
        const pmType = this.state.selected_payment_method.type;

        logMonthlySetupStarted({
            gift_amount: this.state.Gift_amount,
            duration_months: this.state.gift_duration_months,
            guest: !!this.state.guest,
            pm_type: pmType,
            account_id: this.state.account_id || null,
        });

        this.setState({ loading: true });

        GGApi.monthly_gift_setup({
            gift,
            account_id: this.state.account_id,
            payment_method_id: this.state.selected_payment_method.id,
            pm_type: pmType,
            ref: this.state.ref || null,
        }).then((setupRes) => {
            if (!setupRes || !setupRes.plan_id) {
                alert((setupRes && setupRes.message) || 'Could not start monthly gift billing, please try again or contact support.');
                this.setState({ loading: false });
                return;
            }

            // ACH: invoice paid server-side in setup; finalize without card confirm
            if (pmType === 'ACH') {
                return this.finishMonthlyGiftAfterPayment(setupRes, gift);
            }

            const { stripe } = this.props;
            if (!stripe) {
                alert('Payment system did not load. Please refresh and try again.');
                this.setState({ loading: false });
                return;
            }

            return stripe.confirmCardPayment(setupRes.client_secret, {
                payment_method: this.state.selected_payment_method.id,
                receipt_email: this.state.sender_email,
                setup_future_usage: 'off_session',
            }).then((confirmRes) => {
                if (confirmRes.error) {
                    this.removeSelectedPm();
                    const failed_count = this.state.failed_count + 1;
                    this.setState({ loading: false, failed_count });
                    if (this.state.guest) {
                        GGApi.gift_error_guest(confirmRes, this.state.sender_email, failed_count);
                    } else {
                        GGApi.gift_error(confirmRes, this.state.sender_email, failed_count);
                    }
                    alert('Please try a different payment method or contact our team for additional support.');
                    return;
                }
                return this.finishMonthlyGiftAfterPayment(setupRes, gift);
            });
        }).catch((err) => {
            console.log(err);
            alert('Could not start monthly gift billing. Please try again.');
            this.setState({ loading: false });
        });
    }

    showMonthlyGiftSuccessOverlay(nextGiftDate) {
        logMonthlySetupCompleted({
            gift_amount: this.state.Gift_amount,
            duration_months: this.state.gift_duration_months,
            guest: !!this.state.guest,
            account_id: this.state.account_id || null,
        });
        this.setState({
            monthly_gift_success: true,
            monthly_next_gift_date: nextGiftDate || this.getNextMonthlyGiftDateLabel(),
            loading: false,
        });
    }

    getMonthlySuccessDoneUrl() {
        return this.getGiftFlowExitUrl();
    }

    // on load, differentiate between logged in user, and guest 
    // also, check if this is coming from the landing page greeting section
    componentDidMount() {
        // check user vs guest:
        let user = JSON.parse(localStorage.getItem('user'));
        let validToken = '';
        let random_guest_signup = Math.floor( Math.random() * 2);
        // if there's a token, check that it's valid
        if (user) {
            GGApi.checkToken().then(response => {
                validToken = response;
                // if token is not valid, log out
                if (validToken === false) {
                    this.setState({tokenIsValid: false})

                } else if (validToken === true) {
                    // token is valid. set flow as signed in user
                    console.log('user validated. gifting as a user:');

                    //get the list of payment methods
                    GGApi.pm_get(this.isMonthlyFrequency()).then(list => {
                        if(list.length > 0) {
                            if(!list[0].disabled){
                                const firstPm = list[0].items[0];
                                // Monthly gifts require a new-model bank — do not auto-select legacy ba_.
                                if (!(this.isMonthlyFrequency() && isLegacyAchPaymentMethod(firstPm))) {
                                    this.setState({selected_payment_method: firstPm});
                                }
                            }
                        };
                        this.setState(prev => ({
                            payment_methods: updatePmListFeeSubtext(list, prev.Gift_frequency === 'monthly'),
                            from: user.first_name, 
                            sender_email: user.email,
                            guest: false
                        }));
                    })
                };
            });
        
            
        } else if (!user) {
            // if there is no token, continue as a guest
            console.log('going with a guest gifting flow');
            // A/B TEST
            this.setState({guest: true, payment_methods: [], guest_overlay_open: random_guest_signup === 0 ? true : false});
            amplitude.getInstance().setUserId(null);
        };

        // grab gift info if it exists
        if(this.props.greeting) {
            this.setState({greeting: this.props.greeting})
        } 
        if(this.props.from) {
            this.setState({
                from: this.props.from
            });
        }
        if(this.props.Gift_for){
            this.setState({
                Gift_for: this.props.Gift_for
            });
        }
        if(this.props.file){
            this.setState({
                file: this.props.file
            });
        }
        if(this.props.selected_goals){
            this.setState({
                selected_goals: this.props.selected_goals
            });
        }
        // URL params: use props.location.search with fallback to window.location.search so account_id/ref are always read
        const searchString = (this.props.location && this.props.location.search) || (typeof window !== 'undefined' ? window.location.search : '');
        const params = new URLSearchParams(searchString);
        const ref = params.get('ref');
        const giftFor = params.get('Gift_for');
        const accountIdParam = params.get('account_id');
        let accountId = null;
        if (accountIdParam) {
            const parsed = parseInt(accountIdParam, 10);
            if (!isNaN(parsed) && parsed > 0) accountId = parsed;
        }
        if (accountId != null) {
            this.setState({ account_id: accountId });
        }

        // gift matching + monthly_eligible: from registry URL (ref + account_id / gift_for)
        const urlFrequency = params.get('frequency');
        const matchState = this.props.location && this.props.location.state && this.props.location.state.matching;
        if (matchState && matchState.matching_available) {
            this.setState({
                matching_available: true,
                matching_remaining_cents: matchState.matching_remaining_cents || 0,
                matching_multiplier: matchState.matching_multiplier || 2
            });
        }
        if (ref && (accountId != null || giftFor)) {
            const useAccountId = accountId != null;
            GGApi.get_matching_for_gift(ref, useAccountId ? accountId : giftFor, useAccountId).then((m) => {
                this.setState({
                    matching_available: m.matching_available,
                    matching_remaining_cents: m.matching_remaining_cents || 0,
                    matching_multiplier: m.matching_multiplier || 2,
                });
                this.applyMonthlyFlowFromApi(m, urlFrequency, this.props.gift, accountId);
            });
        } else if (urlFrequency === 'monthly') {
            // No registry context — cannot offer monthly; stay one-time
            this.setState({ Gift_frequency: 'one_time', monthly_eligible: false, monthly_gift_flow: false });
        }
        // check if there is a saved gift in process
        if (this.props.gift) {
            this.restoreGiftFromSnapshot(this.props.gift);
        }
        // if all greeting items were collected, skip to second page
        if(this.props.greeting && this.props.from && this.props.Gift_for && this.props.file){
            this.setState({
                Gift_for:       this.props.Gift_for,
                greeting:       this.props.greeting,
                from:           this.props.from,
                file:           this.props.file,
                currentStep:    2
            });
        }

        // grab info from url query params
        const urlParams = new URLSearchParams(window.location.search);
        if(urlParams.get('Gift_for'))        {this.setState({Gift_for:       urlParams.get('Gift_for')})};
        if(urlParams.get('Send_to'))         {this.setState({Send_to:        urlParams.get('Send_to')})};
        if(urlParams.get('channel'))         {this.setState({channel:        urlParams.get('channel')})};
        if(urlParams.get('send_to_email'))   {this.setState({send_to_email:  urlParams.get('send_to_email')})};     
        if(urlParams.get('send_to_number'))  {this.setState({send_to_number: urlParams.get('send_to_number')})};     
        
        // if ref is there, then we have an active receiver and this is the gifting page flow.  
        if(urlParams.get('ref') && urlParams.get('Send_to') && urlParams.get('d')){
            this.setState({receiver: urlParams.get('Send_to'), receiver_number: urlParams.get('d'), ref: urlParams.get('ref')});
        };


        // return from plaid OAuth
        // check if returned from OAuth - there is props plaid token info, and localstorage flow type
        if(this.props.plaid_link_token && this.props.plaid_session) {
            console.log('Continue from existing oauth...')
            
            // get the gift
            let gift = JSON.parse(localStorage.getItem('gift'));
            this.restoreGiftFromSnapshot(gift);

            // set the right step in the flow - step 0, payments open

            this.setState({
                open_payments: true,
                currentStep: 0,
                last_step: 4,
                buttonLinks: true
            })
        }

        // return from Stripe Financial Connections OAuth
        if(this.props.fc_client_secret && this.props.fc_return_session) {
            let gift = JSON.parse(localStorage.getItem('gift'));
            if (gift) {
                this.restoreGiftFromSnapshot(gift);
            }
            this.setState({
                open_payments: true,
                currentStep: 0,
                last_step: 4,
                buttonLinks: true
            });
        }

        // return from login while on payment methods
        if (urlParams.get('resume_payments') === '1') {
            this.resumePaymentsAfterAuth();
            const cleanParams = new URLSearchParams(window.location.search);
            cleanParams.delete('resume_payments');
            const cleanQs = cleanParams.toString();
            const cleanPath = cleanQs ? `/give-a-gift?${cleanQs}` : '/give-a-gift';
            if (this.props.history) {
                this.props.history.replace(cleanPath);
            }
        }


        // amplitude
        if( urlParams.get('Gift_for') || urlParams.get('Send_to') || 
            urlParams.get('channel') || urlParams.get('send_to_email') || 
            urlParams.get('send_to_number') || urlParams.get('ref') || urlParams.get('d') ){
            amplitude.getInstance().logEvent(`gifting: start gift`, {"source": 'invited', "signup-popup": random_guest_signup === 0 ? "Open" : "Close", "user-gifting": user ? "true" : "false" });
        } else {
            amplitude.getInstance().logEvent(`gifting: start gift`, {"source": 'organic', "signup-popup": random_guest_signup === 0 ? "Open" : "Close", "user-gifting": user ? "true" : "false"});
        }
        
    }

    // Navigate the flow
    handleButtonClick() {

        // scroll to top of page
        window.scrollTo(0, 0);

        // check the token at every screen change for registered guests. 
        if(!this.state.guest){
            GGApi.checkToken().then(response => {
                let validToken = response;
                if (validToken === false) {
                    window.location.href = '/';
                    alert('You have been logged out due to inactivity. Please log back in to continue using the Greatest Gift website.');
                };
            });
        }

        let step = this.state.currentStep;
        const isMonthlyFlow = this.isMonthlyGiftFlow();

        // monthly order is Gift Details (1) → Greeting (2) → Receiver (3) → Pay (4)
        if (step === 1) {
            if (isMonthlyFlow) {
                if (this.validateGiftDetailsStep()) {
                    this.advanceAfterGiftDetails(step);
                }
            } else {
                amplitude.getInstance().logEvent('gifting: submit greeting', { step });
                this.setState({ currentStep: step + 1 });
            }

        } else if (step === 2) {
            if (isMonthlyFlow) {
                amplitude.getInstance().logEvent('gifting: submit greeting', { step, gift_frequency: 'monthly' });
                this.logMonthlyStepComplete(step);
                this.setState({ currentStep: step + 1 });
            } else if (this.validateGiftDetailsStep()) {
                this.advanceAfterGiftDetails(step);
            }
        } else if (step === 3) {
            
            // if gifting page flow - check that ref is present, and skip these validations
            if(this.state.ref){
                // if it's a guest - check that there's a sender email
                if (this.state.guest && !validations.validateEmail(this.state.sender_email)) {
                    alert('Please enter a valid sender email address');
                }  else {
                    // create a payment intent
                    if(!this.state.payment_intent){  
                        this.pi_create();
                    }

                    // amplitude
                    amplitude.getInstance().logEvent('gifting: submit send-to', {'step': step});
                    if (this.isMonthlyGiftFlow()) {
                        this.logMonthlyStepComplete(step);
                    }

                    // go to next page
                    step += 1;
                    this.setState(
                        {
                        currentStep: step, 
                                buttonLinks: true
                    });
                }
            }

            // check that at least one of the radio buttons is selected
            if (!this.state.channel && !this.state.ref) {
                alert('Please select one of the gift delivery methods')
            
                // validate the phone number, if it is selected
            } else if (this.state.channel === 'text_message') {
                if(!validations.validatePhone(this.state.send_to_number)) {
                    alert('Please enter a valid 10-digit US phone number in the following format:\nXXX-XXX-XXXX');
                } else if (this.state.guest && !validations.validateEmail(this.state.sender_email)) {
                    alert('Please enter a valid sender email address');
                }  else {
                    
                        if(!this.state.payment_intent){  // create a payment_intent
                            this.pi_create();

                        } else {  // update the recipient in the payment intent
                            //this.pi_update_recipient();
                        }

                    // navigate to next page
                        // if there is no payment method, go to add a payment method
                        //if(!this.state.payment_methods.length) {
                            //this.goToPayments();
                        //} else {
                            //amplitude
                            amplitude.getInstance().logEvent('gifting: submit send-to', {'step': step});
                            if (this.isMonthlyGiftFlow()) {
                                this.logMonthlyStepComplete(step);
                            }
                            step += 1;
                            this.setState({
                                currentStep: step,
                                                buttonLinks: true,
                            });
                        //}
                };
                // validate the email, if it is selected
            } else if (this.state.channel === 'email') {
                if(!validations.validateEmail(this.state.send_to_email)) {
                    alert('Please enter a valid email address');

                // if we're in the guest gifting flow, validate the sender email as a valid email
                } else if (this.state.guest && !validations.validateEmail(this.state.sender_email)) {
                    alert('Please enter a valid sender email address');
                } else {
                    
                    // create a payment_intent
                        if(!this.state.payment_intent){
                            this.pi_create();

                        } else {  // update the recipient in the payment intent
                            //this.pi_update_recipient();
                        }  

                    // navigate to next page
                        // if there is no payment method, go to add a payment method
                        //if(!this.state.payment_methods.length) {
                            //this.goToPayments();
                        //} else {

                            //amplitude
                            amplitude.getInstance().logEvent('gifting: submit send-to', {'step': step});
                            if (this.isMonthlyGiftFlow()) {
                                this.logMonthlyStepComplete(step);
                            }
                            step += 1;
                            this.setState({
                                currentStep: step,
                                                buttonLinks: true,
                            });
                        //};
                };
            };
        
        } else if (step === 4) {
            if (this.isMonthlyFrequency()) {
                this.handleMonthlyGiftSubmit();
                return;
            }
            // not monthly flow, continue with confirming the gift in the regular flow
            console.log('Finished front end flow. Attempting to send gift...');
            // may need to add a captcha here! so no automatic sending occurs by bots
            if(!this.state.selected_payment_method) {
                alert('Please select a payment method');
                return;
            }
            // verify 
            if (this.state.choose_fee_value && isNaN(this.state.choose_fee_value)) {
                alert('Please enter a valid custom fee amount');
                return;
            }

            /* send http post request - send the gift data to the server, and from there to the database */
            let gift = {
                    Gift_for:                       this.state.Gift_for,
                    greeting:                       this.state.greeting,
                    selected_goals:                 this.state.selected_goals,
                    Gift_amount:                    this.state.Gift_amount.slice(1),
                    Gift_delivery_date:             this.state.schedule_delivery === 'later' ? dates.sqlizeDate(this.state.Gift_delivery_date) : '',
                    Gift_delivery_time:             this.state.schedule_delivery === 'later' ? dates.militarizeTime(this.state.Gift_delivery_time.title) : '',
                    schedule_delivery:              this.state.schedule_delivery,
                    Send_to:                        this.state.Send_to,
                    channel:                        this.state.channel,
                    send_to_number:                 this.state.send_to_number,
                    send_to_email:                  this.state.send_to_email.toLowerCase(),
                    gift_from:                      this.state.from,
                    sender_email:                   this.state.sender_email.toLowerCase(),
                    
                    accepted_charges:               this.state.accept_additional_charges,
                    choose_fee_value:               this.state.choose_fee_value ? Number(this.state.choose_fee_value) : 0
            };
            if (this.state.account_id) {
                gift.account_id = this.state.account_id;
            }
            

            
            let centAmount = Number(this.state.Gift_amount.slice(1)) * 100;
            let chosen_fee_cents = Number(this.state.choose_fee_value) * 100;
            // calc potential fee
            let fee;
            if(this.state.selected_payment_method.type === 'CC') {
                //fee = centAmount * 0.035; // break even for 100 dollars at 3.3% or 0.033. 
                fee = ( centAmount * gg_fees.send_fees.cc_variable ) + gg_fees.send_fees.cc_fixed;
            } else if (this.state.selected_payment_method.type === 'ACH') {
                //fee = centAmount * 0.01;
                fee = ( centAmount * gg_fees.send_fees.ach_variable ) + gg_fees.send_fees.ach_fixed;
            };
            fee = Math.floor(fee);

            let new_total_amount = this.state.accept_additional_charges ? centAmount + fee + chosen_fee_cents : centAmount + chosen_fee_cents ;
            
            console.log(`Updating PI amount: ${fee} is ${this.state.accept_additional_charges ? 'added' : 'removed'} as fee. Chosen fee of ${chosen_fee_cents} added. Gift amount: ${centAmount}. Total amount: ${new_total_amount}.`);
            this.setState({loading: true});
            // call the GGApi to update the payment_intent amount
            GGApi.pi_update_amount(this.state.payment_intent, new_total_amount, this.state.Gift_amount, chosen_fee_cents).then(updated_pi_response => {
            //////////////////////////////////////
            // if this is a registered GG user: 
            if (!this.state.guest) {
                
                // send gift with token validation:
                
                /*
                let channel_input = this.state.channel === 'email' ? this.state.send_to_email : this.state.send_to_number;
                GGApi.get_receiver_stripe_acc(this.state.channel, channel_input).then(response => {
                    let recipient = response.receiver_stripe_account;  
                */
                this.setState({loading: true});
                let recipient = null; 
                // check if selected payment is ACH or CC
                if(this.state.selected_payment_method.type === 'CC'){
                    ////
                    GGApi.pi_finalize(this.state.payment_intent, this.state.selected_payment_method, recipient, centAmount, chosen_fee_cents)
                    .then(jsonResponse => {
                        if(jsonResponse.limit_passed){
                            console.log(jsonResponse);
                            if(jsonResponse.limit_fail === 'weekly_limit'){
                                alert(`You have reached your weekly rolling gift limit. Please try a lower gift amount, or wait until ${ dates.jsDate(jsonResponse.next_available.slice(0,10))} when your limit will reset.\nRemaining weekly balance: $${jsonResponse.remaining_weekly}`)
                            } else if (jsonResponse.limit_fail === 'under_minimum') {
                                alert(`The gift amount you have selected does not meet our minimum gift amount requirements. Please try again with a different gift amount.`);
                            } else {
                                alert(`The gift amount you have selected exceeds your account's gift limit of $${jsonResponse.transaction_limit}. Please enter a lower gift amount, or contact our support team at Support@GreatestGiftApp.com for additional information.`);
                            }
                            this.setState({loading: false});
                            return;
                        };

                        if(!jsonResponse.client_secret){
                            alert('logged out. Please log in again.')
                            this.setState({tokenIsValid: false});
                        } else {
                                                
                            let payment_method = this.state.selected_payment_method.id;
                            
                            // check if user requested to save payment_method for next time, if so, save it
                            let future_usage = this.state.selected_payment_method.save_this_method ? 'on_session' : null;
                            let return_url = window.location.href.slice(0,-11)+'gifts';
                            
                            const {stripe, elements} = this.props;
    
                            if (!stripe || !elements) {
                                // Stripe.js has not loaded yet. Make sure to disable form submission until Stripe.js has loaded.
                                console.log('stripe didn\'t load');
                                this.setState({loading: false});
                                return;
                            }
    
                            // confirm the payment intent!
                            stripe.confirmCardPayment(jsonResponse.client_secret, 
                                {
                                    payment_method:         payment_method,
                                    receipt_email:          this.state.sender_email,
                                    setup_future_usage:     future_usage,
                                    return_url:             return_url
                                }
                            ).then(response => {
                                if(response.error){ // if there is an error in processing the charge
                                    this.removeSelectedPm();
                                
                                    let failed_count = this.state.failed_count;
                                    failed_count += 1; 
                                    this.setState({loading: false, failed_count: failed_count});
                                    // send an alert to an admin?
                                    GGApi.gift_error(response, this.state.sender_email, failed_count);
                                    alert('Please try a different payment method or contact our team for additional support.');
                                    return;
                                }
                                // if requested - save the payment method for future use 
                                if(this.state.selected_payment_method.save_this_method ){
                                    let {pm_name, pm_last4, type, id, image} = this.state.selected_payment_method;
                                    GGApi.pm_create(id, type, pm_name, pm_last4, image);
                                };
                                //let used_pm = response.paymentIntent.payment_method;
                                console.log(response);
                                
                                GGApi.upload_media(this.state.file, 'greetings-media').then(response => {
                                    // handle media upload error
                                    let media;
                                    if(response.errors){
                                        console.log(response.errors[0].detail);
                                        alert(response.errors[0].detail + ' \nGift will be sent without the greeting media.')
                                    } else if(response.mediaUrl){
                                        media = response.mediaUrl;
                                    };
                                    let payment_intent = this.state.payment_intent;
                                    
                                    // send gift in gg_db. 
                                    return GGApi.send_gift(gift, media, payment_intent, this.state.selected_payment_method, this.state.ref);
                                }).then((response) => {
                                    this.props.forget_gift();
                                    this.setState({
                                        loading: false,
                                        sent: true,
                                        match_applied: response && response.match_applied === true,
                                        match_amount: response && typeof response.match_amount === 'number' ? response.match_amount : 0
                                    });
                                    amplitude.getInstance().logEvent('gifting: confirm gift', {'gift amount': gift.Gift_amount});
                                });
                            })
                        }
                        
                    })
                    ////
                
                } else if (this.state.selected_payment_method.type === 'ACH'){
                    // check the weekly and transaction limits
                    // create a charge on the backend, with centAmount, pi_id (for transfer group!), pm_id, fee_acceptance, receipt_email
                    
                    GGApi.create_ach_charge(this.state.payment_intent, this.state.selected_payment_method.id, centAmount, this.state.accept_additional_charges, this.state.sender_email, chosen_fee_cents)
                    .then(response => {
                        // check if limits were passed
                        if(response.limit_passed){
                            if(response.limit_fail === 'weekly_limit'){
                                alert(`You have reached your weekly rolling gift limit. Please try a lower gift amount, or wait until ${ dates.jsDate(response.next_available.slice(0,10))} when your limit will reset.\nRemaining weekly balance: $${response.remaining_weekly}`)
                            } else if (response.limit_fail === 'under_minimum') {
                                alert(`The gift amount you have selected does not meet our minimum gift amount requirements. Please try again with a different gift amount.`);
                            } else {
                                alert(`The gift amount you have selected exceeds your account's gift limit of $${response.transaction_limit}. Please enter a lower gift amount, or contact our support team at Support@GreatestGiftApp.com for additional information.`);
                            }
                            this.setState({loading: false});
                            return;
                        };
                        // if other error, alert the user
                        if(!response.success){
                            alert(`We encountered a problem when trying to charge the selected bank account. Please try again, or select a different payment method.`);
                            this.setState({loading: false});
                        } else if (response.success){
                            // start the gg side gift - upload media, then send_gift
                            GGApi.upload_media(this.state.file, 'greetings-media').then(response => {
                                // handle media upload error
                                let media;
                                if(response.errors){
                                    console.log(response.errors[0].detail);
                                    alert(response.errors[0].detail + ' \nGift will be sent without the greeting media.')
                                } else if(response.mediaUrl){
                                    media = response.mediaUrl;
                                };
                                let payment_intent = this.state.payment_intent;
                                
                                return GGApi.send_gift(gift, media, payment_intent, this.state.selected_payment_method, this.state.ref);
                            }).then((response) => {
                                this.props.forget_gift();
                                this.setState({
                                    loading: false,
                                    sent: true,
                                    match_applied: response && response.match_applied === true,
                                    match_amount: response && typeof response.match_amount === 'number' ? response.match_amount : 0
                                });
                                amplitude.getInstance().logEvent('gifting: confirm gift', {'gift amount': gift.Gift_amount});
                            });
                        }
                    }).catch(err => {
                        alert(`We encountered a problem when trying to charge the selected bank account. Please try again, or select a different payment method.`);
                        this.setState({loading: false});
                    })
                }
                
                //});

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////                
            // if this is a guest sending a gift:
            } else if (this.state.guest) {
                // no token validation on this method! 
                /*
                let channel_input = this.state.channel === 'email' ? this.state.send_to_email : this.state.send_to_number;
                GGApi.get_receiver_stripe_acc(this.state.channel, channel_input).then(response => {
                    let recipient = response.receiver_stripe_account;
                    */
                   
                    // for guests, check if the captcha was even filled out successfully!
                   
                    if(!this.state.captcha_token){
                        alert('Please fill out the captcha requirement.'); 
                        this.setState({loading: false});
                        return;
                    };

                    let recipient = null;
                    let centAmount = Number(this.state.Gift_amount.slice(1)) * 100;
                    let chosen_fee_cents = Number(this.state.choose_fee_value) * 100;

                    let captcha = this.state.captcha_token;
                    GGApi.pi_finalize_guest(this.state.payment_intent, this.state.selected_payment_method, recipient, centAmount, this.state.sender_email, captcha, chosen_fee_cents)
                    .then(jsonResponse => {    
                        if(jsonResponse.captcha === false){
                            alert('Encountered error with captcha validation. Please try again!')
                            this.resetCaptcha(guest_payment_recaptcha);
                            this.setState({loading: false});
                            return;
                        };
                        if(jsonResponse.limit_passed){
                            this.setState({loading: false});
                            if(jsonResponse.limit_fail === 'weekly_limit'){
                                alert(`You have reached your weekly rolling gift limit. If you would like to increase your gift limits, please register for an account at app.GreatestGiftApp.com/new_account.`)
                                this.resetCaptcha(guest_payment_recaptcha);
                                return;
                            } else if (jsonResponse.limit_fail === 'under_minimum') {
                                alert(`The gift amount you have selected does not meet our minimum gift amount requirements. Please try again with a different gift amount.`);
                                return;
                            } else {
                                alert(`The gift amount you have selected exceeds guest gift limit of $${jsonResponse.transaction_limit}. If you would like to select a larger gift amount, please register for an account at app.GreatestGiftApp.com/new_account.`);
                                return;
                            }
                        };
                        
                        // check if user requested to save payment_method for next time, if so, save it
                        let payment_method = this.state.selected_payment_method.id;
                        let return_url = window.location.href.slice(0,-11);
                        
                        const {stripe, elements} = this.props;

                        if (!stripe || !elements) {
                            // Stripe.js has not loaded yet. Make sure to disable form submission until Stripe.js has loaded.
                            console.log('stripe didn\'t load');
                            return;
                        }

                        // confirm the payment intent!
                        stripe.confirmCardPayment(jsonResponse.client_secret, 
                            {
                                payment_method:         payment_method,
                                receipt_email:          this.state.sender_email,
                                return_url:             return_url
                            }
                        ).then(response => {
                            if(response.error){
                                this.removeSelectedPm();
                                
                                let failed_count = this.state.failed_count;
                                failed_count += 1; 
                                this.setState({loading: false, failed_count: failed_count});
                                // alert an admin
                                GGApi.gift_error_guest(response, this.state.sender_email, failed_count);
                                alert('Please try a different payment method or contact our team for additional support.');
                                return;
                            }
                            let used_pm = response.paymentIntent.payment_method;
                            console.log(response);

                            GGApi.upload_media(this.state.file, 'greetings-media').then(response => {
                                // handle media upload error
                                let media;
                                if(response.errors){
                                    console.log(response.errors[0].detail);
                                    GGApi.notify_admin(`there was an error when logging a guest gift in the DB, trying to send without media:`, response.errors[0].detail)
                                    alert(response.errors[0].detail + ' \nGift will be sent without the greeting media.')
                                } else if(response.mediaUrl){
                                    media = response.mediaUrl;
                                };
                                let payment_intent = this.state.payment_intent;
                                return GGApi.send_gift_as_guest(gift, media, payment_intent, used_pm, this.state.ref, this.state.opt_in);
                            }).then((response) => {
                                this.props.forget_gift();
                                this.setState({
                                    loading: false,
                                    sent: true,
                                    match_applied: response && response.match_applied === true,
                                    match_amount: response && typeof response.match_amount === 'number' ? response.match_amount : 0
                                });
                                amplitude.getInstance().logEvent('gifting: confirm gift', {'gift amount': gift.Gift_amount});
                                GGApi.admin_log_event('gift confirmed on front end');
                            }).catch(err => {
                                console.log('trying to send gift without media')
                                GGApi.notify_admin(`there was an error when logging a guest gift in the DB, trying to send without media: ${err}`, gift)
                                let payment_intent = this.state.payment_intent;
                                GGApi.send_gift_as_guest(gift, '', payment_intent, used_pm, this.state.ref, this.state.opt_in); 
                            });

                        }).catch(err => {
                            GGApi.notify_admin(`there was an error when logging a guest gift in the DB: ${err}`, gift)
                        })
                    })
                //})
            }

        });

        };  
    }

    handleBackButton() {
        let step = this.state.currentStep;
        // amplitude
        amplitude.getInstance().logEvent('gifting: click back', {'step': step});
        if(this.state.open_payments) {
            this.setState({open_payments: false, currentStep: this.state.last_step})
        } else {
            if (step === 1) {
                this.remember_gift();
                if (this.props.remember_gift_link && this.props.location) {
                    this.props.remember_gift_link(this.props.location.search);
                }
                window.location.href = this.getGiftFlowExitUrl();

            } else if (step === 2 || step === 3) {
                step -= 1;
                this.setState({ currentStep: step });

            } else if (step === 4 && this.state.sent === false && !this.state.monthly_gift_success) {
                step -= 1;
                this.setState(
                    {   
                        currentStep: step,
                        buttonLinks: false
                    });
            }
        }
    }

    goToPayments(){
        this.setState({
            open_payments: true,
            currentStep: 0,
            last_step: this.state.currentStep
        })
        // amplitude
        amplitude.getInstance().logEvent(`gifting: go to payment methods`);
    }

    // form event methods
    handleChange(event) {
        const { name, value} = event.target;
        this.setState({[name]: value});
        if(name === 'other_gift_amount'){
            this.setState({Gift_amount: value})
            // add the $ sign after blurring out of the box, if needed
            if (this.state[name][0] === '$' ) {
                return;
            } else if (this.state[name].length === 0) {
                return;
            } else {
                let $value = '$' + value;
                this.setState({Gift_amount: $value});
            };
        }
    }

    handlePicChange(event) {
        let file = event.target.files[0];
        // try to convert here to jpeg?
        if(!file){
            return;
        }
        if(file.size > 8388608) {
            alert('Please select a photo or video with a max size of 8MBs.');
            return;
        }
        this.setState(
            {file: event.target.files[0]}
        );
    }

    handleRemoveMedia(){
        this.setState({file: null});
    }
    
    handleDateChange(event) {
        const { name, value} = event.target;
        this.setState({[name]: value, date: value});

        if (event.target.value.length === 2 && this.state.date.length === 1) {
            let newValue = value + "/";
            this.setState({[name]: newValue});
        } else if (event.target.value.length === 5 && this.state.date.length === 4) {
            let newValue = value + "/";
            this.setState({[name]: newValue});
        };
        // reset the selected time when choosing today's date - avoid selection of past time in today
        if(event.target.value === dates.today()){
            this.setState({Gift_delivery_time: '', Gift_delivery_shown_time: ''})
        }
        
    }


    handleDatePicker(date, same_or_add_day) {
        // reset the selected time when choosing today's date - avoid selection of past time in today
        if(date === dates.today()){
            this.setState({Gift_delivery_time: '', Gift_delivery_shown_time: ''})
        }

        if(same_or_add_day === 1){
            this.setState({Gift_delivery_date: dates.date_plus_day(date), Gift_delivery_shown_date: date})
        } else {
            this.setState({Gift_delivery_date: date, date: date, Gift_delivery_shown_date: date});
        }
    }
    
    handlePhoneChange(event) {
        const { name, value} = event.target;
        this.setState({[name]: value, phone_support: value});

        if (event.target.value.length === 3 && this.state.phone_support.length === 2) {
            let newValue = value + "-";
            this.setState({[name]: newValue});
        } else if (event.target.value.length === 7 && this.state.phone_support.length === 6) {
            let newValue = value + "-";
            this.setState({[name]: newValue});
        };
        
    }

    handlePastePhone(input_name, formatted_number) {
        this.setState({[input_name]: formatted_number, phone_support: formatted_number});        
    }

    handleDollarInput(event) {
        const { name, value} = event.target;
        
        // add the $ sign after blurring out of the box, if needed
        if (this.state[name][0] === '$' ) {
            return;
        } else if (this.state[name].length === 0) {
            return;
        } else {
            let $value = '$' + value;
            this.setState({[name]: $value});
            if(name === 'other_gift_amount'){
                this.setState({Gift_amount: $value});
            }
        };
        // amplitude
        amplitude.getInstance().logEvent('gifting: select gift amount', {'gift amount': value})

    }

    updateChannel(input) {
        const name = 'channel';
        let value = '';
        if (input === 'channel_email') {
            value = 'email';
        } else if (input === 'channel_text') {
            value = 'text_message';
        };
        
        this.setState({[name]: value});
    }

    // payment section
    
    updateCard(payment_method, save_method){
        // save_method for future use is true or false object.
        
        let pm_logo = '';
        switch(payment_method.card.brand){
            case 'visa':
                pm_logo = 'https://gg-app-images.s3.us-east-2.amazonaws.com/linked_account_logos/logo_CC_visa.png';
                break;
            case 'amex':                
                pm_logo = 'https://gg-app-images.s3.us-east-2.amazonaws.com/linked_account_logos/logo_CC_AmEx.png';
                break;
            case 'diners':
                pm_logo = 'https://gg-app-images.s3.us-east-2.amazonaws.com/linked_account_logos/logo_CC_diners.png';
                break;
            case 'discover':
                pm_logo = 'https://gg-app-images.s3.us-east-2.amazonaws.com/linked_account_logos/logo_CC_discover.png';
                break;
            case 'mastercard':
                pm_logo = 'https://gg-app-images.s3.us-east-2.amazonaws.com/linked_account_logos/logo_CC_mastercard.png';
                break;
            default: 
                pm_logo = 'https://gg-app-images.s3.us-east-2.amazonaws.com/linked_account_logos/logo_CC_generic_card.png';
                break;
        }
        
        // set up the new pm in correct format for ddc
        let new_payment_method = {
            id: payment_method.id,
            type: 'CC',
            main_text: payment_method.card.brand,
            sub_text: '•••• ' + payment_method.card.last4,
            image: pm_logo,
            
            // info to be used to save payment method
            save_this_method: save_method,
            pm_name: payment_method.card.brand, 
            pm_last4: payment_method.card.last4,
        }
        // update - add the GG credit card fees to total amount on the payment intent
        this.pi_update_amount(new_payment_method, this.state.payment_intent);       
        
        // add the payment method to the ddc list:
        let ddc_list = this.state.payment_methods;
        function findCategory(listItem) {
            if(listItem.category_header === 'Credit Cards' && new_payment_method.type === 'CC') {
                return true;
            } else if (listItem.category_header === 'Bank Debits - ACH' && new_payment_method.type === 'ACH'){
                return true;
            } else {
                return false;
            }
        };
        let index = ddc_list.findIndex(findCategory);
        const isMonthly = this.isMonthlyFrequency();
        if(index < 0) {
            let new_index = ddc_list.push({
                id: new_payment_method.type === 'CC' ? 2 : 1,
                category_header: new_payment_method.type === 'CC' ? 'Credit Cards' : 'Bank Debits - ACH',
                category_subtext: getSendFeeCategorySubtext(new_payment_method.type, isMonthly),
                items: [],
                color: new_payment_method.type === 'CC' ? 'gg_red': ''
            }) - 1;
            ddc_list[new_index].items.push(new_payment_method);
        } else {
            ddc_list[index].items.push(new_payment_method);
        };

        // move to next page, and select the new method as the selected method
        this.setState({
            new_payment_method: new_payment_method,
            selected_payment_method: new_payment_method,
            save_method: save_method,
            payment_methods: ddc_list,

            open_payments: false,
            currentStep: 4,
            accept_additional_charges: true,
            
            buttonLinks: true
        });
    }

    bankNext(new_bank){
        // this function is called when a new bank is added to the payment methods list
        const achVerified = new_bank.verified === 1 || new_bank.verified === true;
        // set up the new pm in correct format for ddc
        let new_pm = {
            id: new_bank.method_api_id,
            type: 'ACH',
            verified: achVerified,
            main_text: new_bank.method_name,
            sub_text: '•••• '+new_bank.method_last4,
            image: new_bank.method_logo,
        }
        // add the payment method to the ddc list:
        let ddc_list = this.state.payment_methods;
        function findCategory(listItem) {
            if(listItem.category_header === 'Credit Cards' && new_pm.type === 'CC') {
                return true;
            } else if (listItem.category_header === 'Bank Debits - ACH' && new_pm.type === 'ACH' && achVerified){
                return true;
            } else if (listItem.category_header === 'Bank Debits - ACH (pending verification)' && new_pm.type === 'ACH' && !achVerified){
                return true;
            } else {
                return false;
            }
        };
        let index = ddc_list.findIndex(findCategory);
        const isMonthly = this.isMonthlyFrequency();
        if(index < 0) {
            let new_index = ddc_list.push({
                id: achVerified ? 1 : 3,
                category_header: achVerified ? 'Bank Debits - ACH' : 'Bank Debits - ACH (pending verification)',
                category_subtext: achVerified ?
                getSendFeeCategorySubtext('ACH', isMonthly):
                "Verification Required",
                items: [],
                disabled: !achVerified
            }) - 1;
            ddc_list[new_index].items.push(new_pm);
        } else {
            ddc_list[index].items.push(new_pm);
        };

        // move to next page, and select the new method as the selected method
        this.setState({
            payment_methods: ddc_list,

            open_payments: false,
            currentStep: 4,
            accept_additional_charges: true,
            
            buttonLinks: true
        });
        if(achVerified){
            this.setState({
                new_payment_method: new_pm,
                selected_payment_method: new_pm,
                payment_methods: ddc_list
            }); 
        }

    }    

    removeSelectedPm(){
        // remove selected pm from the ddc list
        let pm = this.state.selected_payment_method;

        function findCategory(listItem) {
            if(listItem.category_header === 'Credit Cards' && pm.type === 'CC') {
                return true;
            } else if (listItem.category_header === 'Bank Debits - ACH' && pm.type === 'ACH'){
                return true;
            } else {
                return false;
            }
        };

        function findPm(listPm) {
            if(listPm.id === pm.id) {
                return true;
            } else {
                return false;
            }
        };

        let ddc_list = this.state.payment_methods;
        let index = ddc_list.findIndex(findCategory);
        let pm_list = ddc_list[index].items;
        let pm_index = pm_list.findIndex(findPm);
        
        // splice the list
        ddc_list[index].items.splice(pm_index, 1);
        // set the new pm list
        this.setState({payment_methods: ddc_list, selected_payment_method: ''});
    }

    /** Drop a saved PM from the step-4 list (after legacy bank removal). Returns updated list. */
    removePmFromListById(pmId) {
        const ddc_list = this.state.payment_methods.map((category) => {
            if (category.category_header !== 'Bank Debits - ACH'
                && category.category_header !== 'Bank Debits - ACH (pending verification)') {
                return category;
            }
            return {
                ...category,
                items: category.items.filter((pm) => pm.id !== pmId),
            };
        });
        this.setState({
            payment_methods: ddc_list,
            selected_payment_method: '',
            button4Active: false,
        });
        return ddc_list;
    }

    /** Legacy ba_ selected during monthly setup — remove, notify, stay or open add-bank UI. */
    handleLegacyBankSelectedForMonthly(item) {
        if (!item || !item.id) {
            return;
        }
        this.setState({ loading: true });
        GGApi.remove_legacy_bank(item.id)
            .then((response) => {
                const updatedList = this.removePmFromListById(item.id);
                const remaining = countSelectablePaymentMethods(updatedList);
                if (remaining > 0) {
                    alert(LEGACY_BANK_EXPIRED_PICK_OTHER_MESSAGE);
                } else {
                    alert((response && response.message) || LEGACY_BANK_EXPIRED_MESSAGE);
                    this.goToPayments();
                }
            })
            .catch((err) => {
                console.log('handleLegacyBankSelectedForMonthly error:', err);
                alert(LEGACY_BANK_EXPIRED_MESSAGE);
                this.goToPayments();
            })
            .finally(() => {
                this.setState({ loading: false });
            });
    }

    handleDDSelection(item, dd_name) {
        console.log('New pm selected');
        if (dd_name === 'payment_method') {
            if (this.isMonthlyGiftFlow() && isLegacyAchPaymentMethod(item)) {
                this.handleLegacyBankSelectedForMonthly(item);
                return;
            }
            // update the payment intent with new pm
            if(this.state.accept_additional_charges){
                this.pi_update_amount(item, this.state.payment_intent);
            }
            // set the newly selected payment method
            this.setState(
                {   selected_payment_method: item, 
                    button4Active: true});
        }
    }

    toggle(){
        // if additional, show in the convenience fees. If false, make the convenience fees 0!
        // update the payment_intent to reflect the convenience fees, or not.
        if(this.state.selected_payment_method){   
            this.pi_update_amount(this.state.selected_payment_method, this.state.payment_intent, true)
        }
        this.setState({accept_additional_charges: !this.state.accept_additional_charges})
        // amplitude
        amplitude.getInstance().logEvent(`gifting: toggle fees`);
    }


    //pi_management
    pi_create(){
        // create a separate charges & transfers pi
        let centAmount = Math.round(Number(this.state.Gift_amount.slice(1)) * 100);
        if(!this.state.guest){
            GGApi.pi_create_separate_registered(centAmount).then(jsonResponse => {
                // need to add application fees here
                if(this.state.selected_payment_method && this.state.accept_additional_charges) {
                    this.pi_update_amount(this.state.selected_payment_method, jsonResponse.pi_id)
                };
                this.setState({payment_intent: jsonResponse.pi_id})
            });
        } else {
            GGApi.pi_create_separate_guest(centAmount).then(jsonResponse => {
                // need to add application fees here
                if(this.state.selected_payment_method && this.state.accept_additional_charges) {
                    this.pi_update_amount(this.state.selected_payment_method, jsonResponse.pi_id)
                };
                this.setState({payment_intent: jsonResponse.pi_id})
            });
        }

    }

    pi_update_recipient(){
        let channel_input = this.state.channel === 'email' ? this.state.send_to_email : this.state.send_to_number;
        let centAmount = Number(this.state.Gift_amount.slice(1)) * 100;

        console.log(`updating PI (recipient).`)
        // check if the new recipient is registered GG user
        GGApi.get_receiver_stripe_acc(this.state.channel, channel_input).then(response => {
            if(response.receiver_stripe_account) {
                if(!this.state.guest){
                    GGApi.pi_update_destination_registered(this.state.payment_intent, response.receiver_stripe_account).then(jsonResponse => {
                        this.setState({payment_intent: jsonResponse.pi_id})
                    });
                } else {
                    GGApi.pi_update_destination_guest(this.state.payment_intent, response.receiver_stripe_account).then(jsonResponse => {
                        this.setState({payment_intent: jsonResponse.pi_id})
                    });
                }
                
            } else {
                if(!this.state.guest){
                    // to avoid issues with transfer_data info updates, create and work with a new pi for separate charges & transfers
                    GGApi.pi_create_separate_registered(centAmount).then(jsonResponse => {
                        if(this.state.selected_payment_method && this.state.accept_additional_charges) {
                            this.pi_update_amount(this.state.selected_payment_method, jsonResponse.pi_id)
                        };
                        this.setState({payment_intent: jsonResponse.pi_id})
                    });
                } else {
                    // to avoid issues with transfer_data info updates, create and work with a new pi for separate charges & transfers
                    GGApi.pi_create_separate_guest(centAmount).then(jsonResponse => {
                        if(this.state.selected_payment_method && this.state.accept_additional_charges) {
                            this.pi_update_amount(this.state.selected_payment_method, jsonResponse.pi_id)
                        };
                        this.setState({payment_intent: jsonResponse.pi_id})
                    });
                }
                
            }
        }) 
    }

    pi_update_amount(method, pi_id, toggle){
        let amount = Number(this.state.Gift_amount.slice(1)) * 100;
        let chosen_fee_cents = Number(this.state.choose_fee_value) * 100;
        
        if((this.state.accept_additional_charges && !toggle )|| (!this.state.accept_additional_charges && toggle )){
            let fee;
            if(method.type === 'CC') {
                //fee = amount * 0.035; // break even for 100 dollars at 3.3% or 0.033. 
                fee = ( amount * gg_fees.send_fees.cc_variable ) + gg_fees.send_fees.cc_fixed;
            } else if (method.type === 'ACH') {
                //fee = amount * 0.01;
                fee = ( amount * gg_fees.send_fees.ach_variable ) + gg_fees.send_fees.ach_fixed;
            };
    
            fee = Math.floor(fee);
            let new_total_amount = amount + fee + chosen_fee_cents;
            
            console.log(`adding ${fee} and chosen fee of ${chosen_fee_cents} to total payment_intent amount. Total amount: ${new_total_amount}. Gift amount: ${amount}.`);
            // call the GGApi to update the payment_intent amount
            GGApi.pi_update_amount(pi_id, new_total_amount, this.state.Gift_amount, chosen_fee_cents).then(jsonResponse => {
                this.setState({payment_intent: jsonResponse.pi_id})
                return jsonResponse.pi_id;
            });

        } else if ((!this.state.accept_additional_charges && !toggle) || (this.state.accept_additional_charges && toggle)){
        
            let new_total_amount = amount + chosen_fee_cents;
            console.log(`removing fees from payment intent. Chosen fees: ${chosen_fee_cents}. Total amount: ${new_total_amount}. Gift amount: ${amount}.`);
            GGApi.pi_update_amount(this.state.payment_intent, new_total_amount, this.state.Gift_amount, chosen_fee_cents).then(jsonResponse => {
                this.setState({payment_intent: jsonResponse.pi_id})
                return jsonResponse.pi_id;
            });
        }
    }

    // recaptcha

    renderCaptcha(){
        if(!this.state.guest || this.state.currentStep !== 4){
            return null;
        } else {
            return (
                <div className='recaptcha_container'>
                    <ReCAPTCHA
                    sitekey={config.recaptcha_siteKey}
                    onChange={this.handleRecaptcha}
                    ref={guest_payment_recaptcha}
                        />
                </div>
            )
        }
    }

    handleRecaptcha(value){
        this.setState({captcha_token: value})
    }

    resetCaptcha(ref){
        ref.current.reset();
        this.setState({captcha_token: ''});
    }

    // thank you, and options
    sendAnotherGift() {
        // token is last validated at gift send step 4, but just in case someone left the computer after that...
        // first, check for valid tokens
        let user = JSON.parse(localStorage.getItem('user'));
        let validToken = '';
        // if there's a token, check that it's valid
        if (user) {
            GGApi.checkToken().then(response => {
                validToken = response;
                // if token is not valid, log out
                if (validToken === false) {
                    this.setState({tokenIsValid: false})

                } else if (validToken === true) {
                    // token is valid. set flow as signed in user
                    console.log('user validated. gifting as a user:');

                    //get the list of payment methods
                    GGApi.pm_get(this.isMonthlyFrequency()).then(list => {
                        const updates = {
                            payment_methods: updatePmListFeeSubtext(list, this.isMonthlyFrequency()),
                            from: user.first_name,
                            guest: false,
                        };
                        if (list.length > 0 && !list[0].disabled) {
                            const firstPm = list[0].items[0];
                            if (!(this.isMonthlyFrequency() && isLegacyAchPaymentMethod(firstPm))) {
                                updates.selected_payment_method = firstPm;
                            }
                        }
                        this.setState(updates);
                    })
                };
            });
        
            // if there is no token, continue as a guest
        } else if (!user) {
            console.log('going with a guest gifting flow');
            this.setState({
                guest: true, 
                payment_methods: [], 
                selected_payment_method: ''
            });
        };

        // reset the gifting flow, but keep some of the sender info if it exists
        this.setState(
            {
            currentStep: 1,
            last_step: 0,
            sent: false,
            monthly_gift_success: false,
            monthly_next_gift_date: '',
            monthly_gift_flow: false,
            Gift_frequency: 'one_time',
            gift_duration_months: 12,

            payment_intent: '',

            Gift_for: '',
            greeting: '',
            selected_goals: [],

            Gift_amount: '',
            Gift_delivery_date: '',
            Gift_delivery_shown_date: '',
            Gift_delivery_time: '',
            Gift_delivery_shown_time: '',
            schedule_delivery: 'later',

            Send_to: '',
            channel: '',
            send_to_number: '',
            send_to_email: '',

            date: '',
            phone_support:'',

            choose_fee_value: 5,

            match_applied: false,
            match_amount: 0
            }, () => {
                const params = new URLSearchParams(window.location.search);
                if (params.get('frequency') === 'monthly' && this.state.monthly_eligible) {
                    this.applyMonthlyFlowFromApi({ monthly_eligible: true }, 'monthly', null);
                }
            });
    }

    handleOverlayBack() {
        window.location.href = this.getGiftFlowExitUrl();
    }

    remember_gift(extraFields){
        this.props.remember_gift(this.buildGiftSnapshot(extraFields));
    }
    
    save_gift_for_oauth(){
        
        GGApi.upload_media(this.state.file, 'greetings-media').then(response => {
            let media;
            // handle media upload error
            if(response.errors){
                console.log(response.errors[0].detail);
                console.log('Error when uploading file. Gift will be sent without the greeting media.');
            } else if(response.mediaUrl){
                media = response.mediaUrl;
            }

            const gift = this.buildGiftSnapshot({
                file: media,
                payment_intent: this.state.payment_intent,
            });
            localStorage.setItem("gift", JSON.stringify(gift));
        });
    }

    // render
    render () {
        if (!this.state.tokenIsValid) {
            return (<Redirect to="/login" />);
        };
        if (this.state.loading){
            return(<GG_loader header_text={!this.state.open_payments ? 'Give A Gift' : 'Add Payment'}/> )
        }

        const giftAuthReturnUrl = this.getGiftAuthReturnUrl();
        const giftPmAuthReturnUrl = this.getGiftAuthReturnUrl({ resumePayments: true });

        return (

        <div>
            <Helmet>
                <title>{`Give a Gift | Greatest Gift`}</title>
                <meta property="og:title" content={`Give a Gift | Greatest Gift`}/>
                <link rel="icon" href="/static/media/logo_var_2.3a7e8fdf.png" />
                <link rel="canonical" href="https://app.greatestgiftapp.com/give-a-gift"/>
                <meta name="description"
                    content='Set a young one on the right financial path. Send monetary gifts for children`s long term savings.' 
                />
                <meta property="og:description" 
                    content='Set a young one on the right financial path. Send monetary gifts for children`s long term savings.' 
                />
                <meta property="og:image" content="https://gg-app-images.s3.us-east-2.amazonaws.com/articles/greatest_gift_money_gifts.png"/>
            </Helmet>

            <Header_for_multistep 
                text={!this.state.open_payments ? 'Give A Gift' : 'Add Payment'}
                handleBackButton={() => this.handleBackButton()}
            />
            
            <main>
                
                {!this.state.open_payments ? 
                    <Tracker numOfSteps={4}
                            currentStep={this.state.currentStep}
                            tags={this.getTrackerTags()}
                            /> 
                : null}

                {/* guest sign up or log in or skip */}
                <Overlay_popup 
                    open            = {this.state.guest_overlay_open}
                    closer          = {true}
                    handleClose     = {() => {this.setState({guest_overlay_open: false}); amplitude.getInstance().logEvent('gifting popup: click x'); }}
                    overlay_title   = 'Sign Up for Lower Fees'
                    wide            = {true}
            
                    body_1          = 'Payments with banks are only available to registered Greatest Gift users.'
                    body_2          = 'Sign up to access minimal 1.0% fees, or continue as a guest and make payments with credit cards.'
                    //image           = {stripe_CC_badge}
                    button_1        = {{text: 'Sign Up',
                                        links: true,
                                        linkTo: `/new_account?source=give-a-gift&${this.props.location.search.slice(1)}`,
                                        handler: () => {amplitude.getInstance().logEvent('signup: click sign up', {'page': 'gifting'});}
                                        }}    
                    button_2        = {{text: 'Continue as Guest',
                                        links: false,
                                        handler: () => { this.setState({guest_overlay_open: false}); amplitude.getInstance().logEvent('gifting popup: click guest');}
                                        }}    
                    joker           = {<div>
                        <p className='small_text'><Link to={`/login?return_to=${encodeURIComponent(giftAuthReturnUrl)}`} className='green_text' onClick={() => { this.remember_gift(); this.props.remember_gift_link(this.props.location.search); amplitude.getInstance().logEvent('gifting popup: click log in')}}>Log in</Link> if you already have an account</p>
                    </div>}
                />

                <Gifting_step_1 currentStep={this.state.currentStep}
                                showAtStep={this.isMonthlyGiftFlow() ? 2 : 1}
                                monthlyGiftFlow={this.isMonthlyGiftFlow()}
                                handleChange={this.handleChange}
                                Gift_for={this.state.Gift_for}
                                greeting={this.state.greeting}
                                buttonText={this.getStepButtonText()}
                                handleButtonClick={this.handleButtonClick}
                                guest={this.state.guest}
                                from={this.state.from}
                                file={this.state.file}
                                handlePicChange={this.handlePicChange}
                                handleRemoveMedia={this.handleRemoveMedia} 
                                occasion={this.state.occasion}
                                select_greeting={(selected_greeting)=> this.setState({greeting: selected_greeting})}/>

                <Gifting_step_2 currentStep={this.state.currentStep}
                                showAtStep={this.isMonthlyGiftFlow() ? 1 : 2}
                                monthlyGiftFlow={this.isMonthlyGiftFlow()}
                                handleChange={this.handleChange}
                                handleDateChange={this.handleDateChange}
                                handleDatePicker={this.handleDatePicker}
                                handleDollarInput={this.handleDollarInput}
                                Gift_amount={this.state.Gift_amount}
                                
                                Gift_delivery_date={this.state.Gift_delivery_date}
                                Gift_delivery_shown_date={this.state.Gift_delivery_shown_date}
                                move_date_by_one={() => this.setState({Gift_delivery_date: dates.date_plus_day(this.state.Gift_delivery_shown_date)})}
                                set_dates_same={() => this.setState({Gift_delivery_date: this.state.Gift_delivery_shown_date})}
                                set_date_plus_one={(new_date) => new_date === dates.today() ? 
                                    this.setState({Gift_delivery_date: dates.date_plus_day(new_date), Gift_delivery_shown_date: new_date, Gift_delivery_time: '', Gift_delivery_shown_time: ''}) 
                                    : 
                                    this.setState({Gift_delivery_date: dates.date_plus_day(new_date), Gift_delivery_shown_date: new_date}) }
                                set_date={(new_date) => new_date === dates.today() ? 
                                    this.setState({Gift_delivery_date: new_date, Gift_delivery_shown_date: new_date, Gift_delivery_time: '', Gift_delivery_shown_time: ''}) 
                                    : 
                                    this.setState({Gift_delivery_date: new_date, Gift_delivery_shown_date: new_date}) }
                                
                                schedule_delivery={this.state.schedule_delivery}
                                handleRadioClick={(schedule_delivery) => this.setState({schedule_delivery: schedule_delivery})}
                                Gift_delivery_time={this.state.Gift_delivery_time}
                                Gift_delivery_shown_time={this.state.Gift_delivery_shown_time}
                                update_timezone={(selection) => this.setState({timezone: selection})}
                                handleHourSelection={(eastern_time, selection) => this.setState({Gift_delivery_time: eastern_time, Gift_delivery_shown_time: selection})}
                                date={this.state.date}
                                buttonText={this.getStepButtonText()}
                                handleButtonClick={this.handleButtonClick}
                                set_amount={(new_amount) => this.setState({Gift_amount: new_amount}) }
                                other_gift_amount={this.state.other_gift_amount}
                                matching_available={this.state.matching_available}
                                matching_remaining_cents={this.state.matching_remaining_cents}
                                matching_multiplier={this.state.matching_multiplier}
                                toggle_matching_help={() => this.setState({ matching_help_box: !this.state.matching_help_box })}
                                toggle_monthly_duration_help={() => this.setState({ monthly_duration_help_box: !this.state.monthly_duration_help_box })}
                                Gift_frequency={this.state.Gift_frequency}
                                monthly_eligible={this.state.monthly_eligible}
                                setGiftFrequency={this.setGiftFrequency}
                                gift_duration_months={this.state.gift_duration_months}
                                setGiftDurationMonths={this.setGiftDurationMonths}
                                />

                <Gifting_step_3 currentStep={this.state.currentStep}
                                showAtStep={3}
                                handleChange={this.handleChange}
                                handlePhoneChange={this.handlePhoneChange}
                                handlePastePhone={this.handlePastePhone}
                                Send_to={this.state.Send_to}
                                send_to_number={this.state.send_to_number}
                                send_to_email={this.state.send_to_email}
                                buttonText={this.getStepButtonText()}
                                handleButtonClick={this.handleButtonClick}
                                updateChannel={this.updateChannel}
                                guest={this.state.guest}
                                sender_email={this.state.sender_email}
                                channel={this.state.channel}
                                receiver_number={this.state.receiver_number}
                                receiver={this.state.receiver}
                                />

                <Gifting_step_4 currentStep={this.state.currentStep}
                                showAtStep={4}
                                isMonthlyGift={this.isMonthlyFrequency()}
                                gift_duration_months={this.state.gift_duration_months}
                                Gift_for={this.state.Gift_for}
                                greeting={this.state.greeting}
                                selected_goals={this.state.selected_goals}
                                Gift_amount={this.state.Gift_amount}
                                Gift_delivery_date={this.state.Gift_delivery_date}
                                Gift_delivery_shown_date={this.state.Gift_delivery_shown_date}
                                Gift_delivery_time={this.state.Gift_delivery_time}
                                Gift_delivery_shown_time={this.state.Gift_delivery_shown_time}
                                schedule_delivery={this.state.schedule_delivery}
                                timezone={this.state.timezone}
                                Send_to={this.state.Send_to}
                                send_to_number={this.state.send_to_number}
                                send_to_email={this.state.send_to_email}
                                buttonText={this.getStepButtonText()}
                                handleButtonClick={this.handleButtonClick}
                                goToPayments={this.goToPayments}
                                guest={this.state.guest}
                                from={this.state.from}
                                handleDDSelection={this.handleDDSelection}
                                button4Active={this.state.button4Active}
                                payment_methods={this.state.payment_methods}
                                selected_payment_method={this.state.selected_payment_method}
                                accept_additional_charges={this.state.accept_additional_charges}
                                toggle={this.toggle}
                                opt_in={this.state.opt_in}
                                opt_in_out={() => {this.setState({opt_in: !this.state.opt_in})}}
                                gift_media={this.state.file}
                                choose_fee_value={this.state.choose_fee_value}
                                handleChooseFeeAmount={(input) => {
                                    this.setState({choose_fee_value: input});
                                    //this.pi_update_amount();
                                    amplitude.getInstance().logEvent('gifting: choose GG platform fee amount', {'chosen amount': input});
                                    }}
                                toggle_gg_fee_help={() => {this.setState({gg_help_box: !this.state.gg_help_box})}}
                                matching_available={this.state.matching_available}
                                matching_remaining_cents={this.state.matching_remaining_cents}
                                matching_multiplier={this.state.matching_multiplier}
                                />

                {this.renderCaptcha()}
                
                { this.state.open_payments ?
                
                <Payment_methods elements={this.props.elements} 
                                stripe={this.props.stripe}
                                guest={this.state.guest}
                                open_payments={this.state.open_payments} 
                                updateCard={this.updateCard}
                                bankNext={this.bankNext}
                                remember_gift={this.remember_gift}
                                isMonthlyGift={this.isMonthlyFrequency()}

                                save_gift_for_oauth={this.save_gift_for_oauth}
                                plaid_link_token={this.props.plaid_link_token} 
                                plaid_session={this.props.plaid_session}
                                cleanupOauth={this.props.cleanupOauth}
                                fc_client_secret={this.props.fc_client_secret}
                                fc_return_session={this.props.fc_return_session}
                                cleanupFcOauth={this.props.cleanupFcOauth}
                                remember_gift_link={() => {this.props.remember_gift_link(this.props.location.search)}}
                                return_to={giftPmAuthReturnUrl}
                                />
                            :
                null
                }

                <div className='gifting_footer'>
                    <a href='https://www.greatestgiftapp.com' target='_blank' rel="noreferrer">
                        <img src={gg_icon} alt='gg icon'/>
                    </a>
                    <p className='tiny_text'>Greatest Gift Inc.</p>
                    <p className='small_text'>|</p>
                    <a href='/legal?active=privacy' target='_blank' className='tiny_text' rel="noreferrer">Privacy</a>
                    <a href='/legal' target='_blank' rel="noreferrer" className='tiny_text'>Terms</a>
                    <a href='https://www.greatestgiftapp.com/#faq' target='_blank' rel="noreferrer" className='tiny_text'>FAQ</a>
                </div>
            
            </main>
            {this.state.sent && !this.state.monthly_gift_success ?
            <GG_confetti />
            : null}
            <Monthly_gift_success
                open={this.state.monthly_gift_success}
                Gift_for={this.state.Gift_for}
                Send_to={this.state.Send_to}
                Gift_amount={this.state.Gift_amount}
                gift_duration_months={this.state.gift_duration_months}
                next_gift_date={this.state.monthly_next_gift_date}
                doneUrl={this.getMonthlySuccessDoneUrl()}
                onClose={() => { window.location.href = this.getMonthlySuccessDoneUrl(); }}
            />
            <Gifting_thank_you 
                sent={this.state.sent && !this.state.monthly_gift_success}
                guest={this.state.guest}
                param1={this.state.Send_to}
                param2={this.state.Gift_for}
                sendAnotherGift={this.sendAnotherGift}
                handleOverlayBack={this.handleOverlayBack}
                match_applied={this.state.match_applied}
                match_amount={this.state.match_amount}
                gift_amount={this.state.Gift_amount ? parseFloat(String(this.state.Gift_amount).replace(/^\$/, '').replace(/,/g, '')) : 0}
                />

             <Overlay_popup 
                    open            = {this.state.gg_help_box}
                    closer          = {true}
                    handleClose     = {() => {
                        this.setState({gg_help_box: false})
                    }
                    }
                    overlay_title   = 'What this fee covers'
                    joker           = {<div className='align_left overlay_text_container '>
                        <p className='small_text'>Every gift takes real work to deliver. From technology that ensures your gift arrives smoothly, to customer support, and building new features.</p>
                        <p className='small_text'>Your optional fee helps us:</p>
                        <ul> 
                        <li><p className='small_text'>Deliver your gift reliably and securely with emails and text messages</p>
                        </li>
                        <li><p className='small_text'>Support customer service, email/text reminders, and communication tools</p>
                        </li>
                        <li><p className='small_text'>Prevent fraud and monitor transactions for safety</p>
                        </li>
                        <li><p className='small_text'>Maintain the platform's technology infrastructure</p>
                        </li>
                        <li><p className='small_text'>Build new features and gifting experiences</p>
                        </li>
                        <li><p className='small_text'>Create better tools to help kids grow financially</p>
                        </li>                            
                        </ul>
                    
                    <p className='small_text'>Every contribution, big or small, helps us keep going. We're truly grateful for your support</p>

                    </div>}
                />

             <Overlay_popup
                    open={this.state.matching_help_box}
                    closer={true}
                    handleClose={() => this.setState({ matching_help_box: false })}
                    overlay_title="What is gift matching?"
                    joker={<div className='align_left overlay_text_container'>
                        <p className='small_text'>Someone close to {this.state.Gift_for || 'this recipient'} has turned on gift matching. </p>
                        <p className='small_text'>That means when you give a gift, they add an extra match on top, so your gift goes twice as far. The full combined amount goes toward the recipient&apos;s goals. <br></br><br></br>Pretty great, right?</p>
                    </div>}
                />

             <Overlay_popup
                    open={this.state.monthly_duration_help_box}
                    closer={true}
                    handleClose={() => this.setState({ monthly_duration_help_box: false })}
                    overlay_title="What is a monthly gift?"
                    joker={<div className='align_left overlay_text_container'>
                        <p className='small_text'>
                            A monthly gift sends the same amount to {this.state.Gift_for || 'the recipient'} every month for a number of months you choose.
                        </p>
                        <p className='small_text'>
                            You're charged once per month, and a new gift is automatically sent each time. You don't need to come back and send it again.
                        </p>
                        <p className='small_text'>
                            You can choose to cancel at any time, and no more gifts will be sent.
                        </p>
                    </div>}
                />

           <div className='buffer'></div>

        </div>
        );
    }
}

export default Main_gift_flow;